import React, { PureComponent, PropTypes } from 'react';
import classnames from 'classnames';
import Autocomplete from '../autocomplete';
import Toggle from '../toggle';
import { localise } from '../../services/Language';

class MainDetails extends PureComponent {
    constructor(props, ...args) {
        super(props, ...args);
        this.state = {};
    }

    render() {
        let { canSave, dataComplete, description, isPublic, languageSuggestions, name, onDeckDetailChange, onDeckVisibilityChange, onLanguageChange, onResetDeck, onSaveDeck, targetLanguage } = this.props;

        let hasError = isPublic && (name.trim() === '' || description.trim() === '');

        let nameLabelClasses = classnames({ empty: !name });
        let nameInputClasses = classnames({ warning: hasError && !name.trim() });
        let langLabelClasses = classnames({ empty: !targetLanguage });
        let descLabelClasses = classnames({ empty: !description });
        let descInputClasses = classnames({ warning: hasError && !description.trim() });
        let publicToggleClasses = classnames({
            'fa fa-exclamation-triangle warning': isPublic && (hasError || !dataComplete)
        });
        let publicToggleHintClasses = classnames({
            'fa fa-level-up warning throb': isPublic && hasError,
            'fa fa-level-down warning throb': !hasError && !dataComplete
        });

        return (<div className="main-details">
            <div className="input">
                <label htmlFor="name" className={ nameLabelClasses }>{ localise('Name') }</label>
                <input type="text" id="name" name="name" placeholder={ name ? '' : localise('Name')} className={ nameInputClasses } value={ name || '' } onChange={ onDeckDetailChange } />
            </div>
            <div className="input">
                <label htmlFor="targetLanguage" className={ langLabelClasses }>{ localise('Language') }</label>
                <Autocomplete className="target-language" placeholder={ targetLanguage ? '' : localise('Language') } value={ targetLanguage  } onChange={ onLanguageChange } suggestions={ languageSuggestions } />
            </div>
            <div className="input">
                <label htmlFor="description" className={ descLabelClasses }>{ localise('Description') }</label>
                <textarea id="description" name="description" placeholder={ localise('Description') } className={ descInputClasses } value={ description || '' } onChange={ onDeckDetailChange } />
            </div>
            <div className="input">
                <label>{ localise('Share publicly') }</label>
                <div className="group">
                    <Toggle onToggle={ onDeckVisibilityChange } toggled={ isPublic } />
                </div>
            </div>
            <div className="buttons">
                <button onClick={ onResetDeck }>{ localise('Reset') }</button>
                <button onClick={ onSaveDeck } disabled={ !canSave || hasError }>{ localise('Save') }</button>
                <span className={ publicToggleClasses }></span>
                <span className={ publicToggleHintClasses }></span>
            </div>
        </div>);
    }
}

MainDetails.propTypes = {
    canSave: PropTypes.bool,
    dataComplete: PropTypes.bool.isRequired,
    description: PropTypes.string,
    isPublic: PropTypes.bool,
    languageSuggestions: PropTypes.arrayOf(PropTypes.string).isRequired,
    name: PropTypes.string,
    onDeckDetailChange: PropTypes.func.isRequired,
    onDeckVisibilityChange: PropTypes.func.isRequired,
    onLanguageChange: PropTypes.func.isRequired,
    onResetDeck: PropTypes.func.isRequired,
    onSaveDeck: PropTypes.func.isRequired,
    targetLanguage: PropTypes.string
};

export default MainDetails;


// WEBPACK FOOTER //
// ./src/components/deckeditor/maindetails.js